import type { RootState } from '@core/store';
import type { PrintLog, PrintElement } from '@features/printer/types';

import { useSelector } from 'react-redux';

import { useAppDispatch } from '@core/store/hooks';

import {
  addNewLog,
  updateLog,
  addNewLogs,
  addNewLogFromPrinterElement,
} from '@features/printer/slices/printer-log-slice';

export const usePrinterLog = () => {
  const dispatch = useAppDispatch();
  const logs = useSelector((state: RootState) => state.printerLog.logs);

  const addLog = (log: PrintLog) => {
    dispatch(addNewLog(log));
  };
  const addLogs = (log: PrintLog[]) => {
    dispatch(addNewLogs(log));
  };

  /** Logs the document; pass `id` to let the print job update this entry (status, duration) */
  const addLogFromPrinterElement = (printElement: PrintElement, pickingType: string, id?: string) => {
    dispatch(addNewLogFromPrinterElement({ printElement, pickingType, id }));
  };

  return {
    logs,
    addLog,
    addLogs,
    updateLog: (id: string, patch: Partial<PrintLog>) => dispatch(updateLog({ id, patch })),
    addLogFromPrinterElement,
  };
};
